import { render } from "./NetworkError.vue?vue&type=template&id=198ce7ad&scoped=true"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-198ce7ad"

export default script